module.exports = __webpack_public_path__ + "img/sup_deposit_crypto1.94e54ddd.jpg";